import { mock } from "./mockData.js";

// 👉 Un flag par endpoint : passe chacun à `false` au fur et à mesure que
// les routes de Clément sont prêtes, plutôt que tout basculer d'un coup.
// Tant qu'un flag est à `true`, cet endpoint tourne sur mockData.js.
const USE_MOCK = {
  config: false,
  pheno: false,
  aleas: false,
  pertes: false,
  eau: false,
  marge: false,
  subvention: true,
  territoire: true,
  exportPptx: true,
};

const MOCK_TRACC_UNTIL_API_READY = false;

const BASE_URL = "https://api2050.diagorisk.com";

/**
 * Toutes les routes DiagoRisk sont en POST, avec un token Bearer lu dans
 * localStorage à chaque appel (comme dans le reste de l'appli).
 * Si la réponse contient une clé "error", on la remonte comme une erreur JS
 * classique pour que useFetch (loading/error) la gère normalement.
 */
async function apiFetch(endpoint, body) {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}/${endpoint}/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Erreur API ${endpoint} (${response.status})`);
  }

  const data = await response.json();

  if (data && "error" in data) {
    throw new Error(data.error);
  }

  return data;
}

/**
 * Contrat API attendu côté RPlumber (voir README.md pour le détail complet).
 * Toute la logique métier (blend hybride RCP4.5/8.5, lissage, calculs de marge,
 * actualisation, etc.) reste côté R — le front ne fait qu'afficher le JSON reçu.
 *
 * ⚠️ Les noms d'endpoints ci-dessous ("config", "eau", "irrigation", ...) sont
 * ceux du contrat qu'on avait posé — à aligner avec les vrais noms de routes
 * une fois côté Clément (ex: peut-être "config2050", "eauJournalier", etc.).
 */
export const api = {
  getConfig: (params = {}) => (USE_MOCK.config ? mock.getConfig(params) : apiFetch("config", params)),

  getEauIrrigation: (params) =>
    USE_MOCK.eau
      ? mock.getEauIrrigation(params)
      : MOCK_TRACC_UNTIL_API_READY && params.rcp === "tracc"
      ? mock.getEauIrrigationTRACC(params)
      : apiFetch("eau", params),

  getPheno: (params) =>
    USE_MOCK.pheno
      ? mock.getPheno(params)
      : MOCK_TRACC_UNTIL_API_READY && params.rcp === "tracc"
      ? mock.getPhenoTRACC(params)
      : apiFetch("pheno", params),

  getAleas: (params) =>
    USE_MOCK.aleas
      ? mock.getAleas(params)
      : MOCK_TRACC_UNTIL_API_READY && params.rcp === "tracc"
      ? mock.getAleasTRACC(params)
      : apiFetch("aleas", params),

  getPertes: (params) =>
    USE_MOCK.pertes
      ? mock.getPertes(params)
      : MOCK_TRACC_UNTIL_API_READY && params.rcp === "tracc"
      ? mock.getPertesTRACC(params)
      : apiFetch("pertes", params),

  getMarge: (params) =>
    USE_MOCK.marge
      ? mock.getMarge(params)
      : apiFetch("marge", params),

  getSubvention: (params) =>
    USE_MOCK.subvention
      ? mock.getSubvention(params)
      : apiFetch("subvention", params),

  getTerritoire: (params) =>
    USE_MOCK.territoire
      ? mock.getTerritoire(params)
      : apiFetch("territoire", params),


  // Export PPTX : cas particulier, la réponse n'est pas du JSON mais un blob binaire
  exportPptx: async (params) => {
    if (USE_MOCK.exportPptx) return mock.exportPptx(params);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/export/pptx/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(params),
    });
    if (!response.ok) {
      throw new Error(`Erreur export PPTX (${response.status})`);
    }
    return response.blob();
  },
};
